<template>
  <div class="sizerDetail">
    <!-- 文本组件功能 -->
    <div
      class="scrollItem"
      v-if="
        [
          'status',
          'text',
          'textarea',
          'radio',
          'checkbox',
          'richTextWid',
          'new-rel-radio',
          'relation-check',
          'label',
        ].indexOf(sizerDetailData.FilterField.type) !== -1
      "
    >
      <!-- 文本场景一： 多表 -->
      <div class="sizer-search" v-if="sizerDetailData.activeName === 'text'">
        <el-input
          size="small"
          placeholder="请搜索"
          :disabled="sizerDisabled"
          :prefix-icon="Search"
          v-model="newSizerDetailData.FilterValue[0]"
          @change="transferFun('textOne')"
        >
        </el-input>
        <el-button size="small" type="primary" @click="transferFun('textOne')">搜索</el-button>
      </div>
      <!-- 文本场景二：单表或者表多表不同源 -->
      <template v-if="sizerDetailData.activeName === 'select' || sizerDetailData.activeName === 'customize' || sizerDetailData.activeName === 'dictionary'">
        <!-- 文本组件场景二：扩大样式显示 -->
        <div
          style="height: 100%"
          v-if="((!sizerDetailData.expandStyle || sizerDetailData.expandStyle === 'stop') && sizerDetailData.w >= 4 && sizerDetailData.h >= 12) || sizerDetailData.expandStyle === 'portrait'"
        >
          <div class="sizer-select">
            <div v-if="sizerDetailData.FilterValue.length > 0" class="sizer-select-list">
              {{sizerDetailData.FilterValue[0]}}
              <el-icon @click="delFilterValue(0)"><Close /></el-icon>
            </div>
            <div v-if="sizerDetailData.FilterValue.length > 1" class="sizer-select-list">+{{sizerDetailData.FilterValue.length - 1}}</div>
            <el-icon class="sizer-select-bottom"><ArrowDown /></el-icon>
          </div>
<!--
          <el-select
            v-model="sizerDetailData.FilterValue"
            multiple
            collapse-tags
            placeholder="请选择"
            class="teshuStyle scrollStyleItem"
            teleported="false"
            @visible-change="transferStatusFun"
            @change="transferFun('textTwo')"
            style="width: 100%"
          >
            <el-input
              style="margin-top: 3px"
              class="filter-number input-clock"
              placeholder="请选择"
              clearable
              v-model="sizerDetailData.FilterValue[0]"
            >
              <i slot="suffix" class="el-input__icon el-icon-date"></i>
            </el-input>
          </el-select>
-->
          <el-input
            style="margin-top: 9px"
            placeholder="请搜索"
            v-model="newSizerDetailData.searchName"
            :disabled="sizerDisabled"
          >
            <template #prefix>
              <el-icon class="el-input__icon"><Search /></el-icon>
            </template>
          </el-input>
          <div class="tabItemTree enlarge">
            <el-scrollbar v-if="(sizerDetailData.activeName === 'select' && sizerDetailData.textDataSelShow.length > 0) || (sizerDetailData.activeName === 'customize' && sizerDetailData.FilterCustomize && sizerDetailData.FilterCustomize.length > 0) || (sizerDetailData.activeName === 'dictionary' && sizerDetailData.FilterCustomize && sizerDetailData.FilterCustomize.length > 0)">
              <el-checkbox
                :indeterminate="sizerDetailData.isIndeterminate"
                v-model="newSizerDetailData.checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >

              <el-checkbox-group
                style="width: 100%"
                v-model="newSizerDetailData.FilterValue"
                @change="transferFun('textTwo')"
              >
              <template v-for="(Sel, j) in (sizerDetailData.activeName === 'select' ? sizerDetailData.textDataSelShow : (sizerDetailData.FilterCustomize || []))">
                <el-checkbox
                  v-if="isShowFun(Sel, sizerDetailData.searchName)"
                  :value="Sel"
                  :disabled="sizerDisabled"
                  :key="j"
                  >{{ Sel }}</el-checkbox>
              </template>
              </el-checkbox-group>
            </el-scrollbar>
            <template v-else>
              <div v-if="sizerDisabled == true" class="textDataStyle">————数据展示请前往客户端查看————</div>
              <div v-else class="textDataStyle">————暂无数据————</div>
            </template>
          </div>
        </div>
        <div v-else-if="(sizerDetailData.activeName === 'customize' || sizerDetailData.activeName === 'dictionary') && sizerDetailData.expandStyle === 'horizontal'" class="sizer-block">
          <el-checkbox-group v-model="newSizerDetailData.FilterValue" @change="transferFun('textTwo')">
            <el-checkbox v-for="(its, index) in (sizerDetailData.FilterCustomize || [])"
                         :key="index" :value="its"></el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- 文本组件场景二：缩小样式显示 -->
        <div v-else>
          <el-popover
            placement="bottom"
            :width="width"
            trigger="click"
            popper-class="auto-popover"
            @show="transferStatusFun(true)"
            @hide="transferStatusFun(false)"
          >
            <!-- 展示选择数据 -->
            <template #reference>
              <div style="width: 100%;position: relative;" @click="getWidth($event)" ref="sizer1">
              <el-select
                v-model="newSizerDetailData.FilterValue"
                multiple
                collapse-tags
                :teleported="false"
                placeholder="请选择"
                class="teshuStyle scrollStyleItem"
                style="width: 100%;height: 100%;overflow: hidden;"
                @visible-change="(val) => visibleChange(val, 'sizer1')"
                @remove-tag="transferFun('textTwo')"
              >
                <el-input
                  style="margin-top: 3px"
                  class="filter-number input-clock"
                  placeholder="请选择"
                  :disabled="false"
                  clearable
                  v-model="newSizerDetailData.FilterValue[0]"
                >
                  <template #suffix>
                    <el-icon><Calendar /></el-icon>
                  </template>
                </el-input>
              </el-select>
            </div>
            </template>
            

            <div class="textStyleTwo">
              <el-input
                style="margin-top: 9px;"
                placeholder="请搜索"
                :clearable="true"
                size="small"
                v-model="newSizerDetailData.searchName"
                :disabled="sizerDisabled"
              >
                <template #prefix>
                  <el-icon class="el-input__icon el-icon-search" style="margin-top: 0; line-height: 30px"><Search /></el-icon>
                </template>
              </el-input>
              <div class="tabItemTree shrink">
                <el-scrollbar style="height: 100%;">
                  <template v-if="(sizerDetailData.activeName === 'select' && sizerDetailData.textDataSelShow.length > 0) || (sizerDetailData.activeName === 'customize' && sizerDetailData.FilterCustomize && sizerDetailData.FilterCustomize.length > 0) || (sizerDetailData.activeName === 'dictionary' && sizerDetailData.FilterCustomize && sizerDetailData.FilterCustomize.length > 0)">
                    <el-checkbox
                      class="allCheck"
                      :indeterminate="sizerDetailData.isIndeterminate"
                      :disabled="sizerDisabled"
                      v-model="newSizerDetailData.checkAll"
                      @change="handleCheckAllChange"
                      >全选</el-checkbox
                    >

                    <el-checkbox-group
                      v-model="newSizerDetailData.FilterValue"
                      @change="transferFun('textTwo')"
                    >
                    <template v-for="(Sel, j) in (sizerDetailData.activeName === 'select' ? sizerDetailData.textDataSelShow : (sizerDetailData.FilterCustomize || []))">
                      <el-checkbox
                        v-if="isShowFun(Sel, sizerDetailData.searchName)"
                        :value="Sel"
                        :disabled="sizerDisabled"
                        :key="j"
                        >{{ Sel }}</el-checkbox>
                    </template>
                    </el-checkbox-group>
                  </template>

                  <template v-else>
                    <div v-if="sizerDetailData.skeletonLoading" style="text-align: center">加载中......</div>
                    <div v-else class="textDataStyle">————暂无数据————</div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
          </el-popover>
        </div>
      </template>
    </div>

    <!-- 选择人员 -->
    <div
      class="scrollItem user"
      v-if="sizerDetailData.FilterField.type === 'relation-user'"
    >
      <div v-if="!sizerDetailData.synchronousOrg && (!sizerDetailData.organize || sizerDetailData.organize.length === 0)" @click="transferFun('user')" class="user-cc">
        <el-tag
          v-if="sizerDetailData.FilterValue && sizerDetailData.FilterValue.length > 0"
          type="info"
          closable
          size="medium"
          :disable-transitions="false"
          @close="handleClose(0)">
          {{ sizerDetailData.FilterValue[0].name || sizerDetailData.FilterValue[0].realname || sizerDetailData.FilterValue[0] }}
        </el-tag>
        <el-tag
          v-if="sizerDetailData.FilterValue && sizerDetailData.FilterValue.length > 1"
          type="info"
          size="medium"
          :disable-transitions="false">
          +{{ sizerDetailData.FilterValue.length }}
        </el-tag>
        <template v-if="!sizerDetailData.FilterValue || sizerDetailData.FilterValue.length === 0">请选择</template>
        <el-icon class="sizer-select-bottom"><ArrowDown /></el-icon>
      </div>
      <!-- <el-select
        v-if="!sizerDetailData.synchronousOrg && (!sizerDetailData.organize || sizerDetailData.organize.length === 0)"
        v-model="sizerDetailData.FilterValue"
        multiple
        collapse-tags
        :disabled="sizerDisabled"
        placeholder="请选择"
        style="width: 100%"
        class="scrollStyleItem"
        teleported="false"
        @visible-change="transferStatusFun"
        :automatic-dropdown="true"
        @remove-tag="updatePeople()"
        @focus="transferFun('user')"
      ></el-select> -->
      <el-scrollbar v-else class="sizer-scrollbar">
        <el-tree :props="defaultProps"
                 :load="loadNode"
                 lazy
                 node-key="organizationId"
                 :default-expanded-keys="defaultShowNodes"
                 @node-click="handleNodeClick">
                 <template #default="{ node }">
                  <span class="custom-tree-node">
                    <span :style="getColor(node.data.organizationId)">{{ node.label }}</span>
                  </span>
                 </template>
        </el-tree>

      </el-scrollbar>
    </div>
    <!-- 组织和角色 -->
    <el-select
      v-if="['organization', 'roule'].includes(sizerDetailData.FilterField.type)"
      v-model="newSizerDetailData.FilterValue"
      multiple
      collapse-tags
      placeholder="请选择"
      style="width: 100%"
      class="scrollStyleItem"
      teleported="false"
      :automatic-dropdown="true"
      @remove-tag="updatePeople()"
      @focus="transferFun('user')"
    ></el-select>
    <!-- 数值 -->
    <div
      class="scrollItem"
      v-if="sizerDetailData.FilterField.type === 'number'"
    >
      <el-select
        v-model="newSizerDetailData.FilterField.conditionValue"
        placeholder="请选择"
        :disabled="sizerDisabled"
        :teleported="true"
        @visible-change="transferStatusFun"
        class="scrollStyleItem"
        style="width: 100%; margin-bottom: 10px"
        @change="numberTypeChange()"
      >
        <el-option
          v-for="(item2, itemIndex) in sizerDetailData.FilterField.condition"
          :key="itemIndex"
          :value="item2.val"
          :label="item2.name"
        />
      </el-select>
      <!-- 数字情形一 -->
      <template v-if="
          ['gt', 'gte', 'lt', 'lte'].indexOf(
            sizerDetailData.FilterField.conditionValue
          ) !== -1
        ">
        <el-input
          v-if="typeof sizerDetailData.FilterValue[0] !== 'object'"
          type="number"
          style="margin-top: 3px"
          class="filter-number input-clock"
          v-model="newSizerDetailData.FilterValue[0]"
          :disabled="sizerDisabled"
          @change="transferFun('number')"
        />
        <el-input v-else-if="sizerDetailData.FilterValue[0] && sizerDetailData.FilterValue[0].name" v-model="newSizerDetailData.FilterValue[0].name" size="small" />
      </template>
      <!-- 数字情形二 -->
      <el-input
        type="number"
        style="margin-top: 3px; width: 44%; float: left"
        v-model="newSizerDetailData.FilterValue[0]"
        :disabled="sizerDisabled"
        @change="transferFun('two_number')"
        class="filter-number-list input-clock"
        v-if="sizerDetailData.FilterField.conditionValue === 'between'"
      />
      <div
        style="
          display: inline-block;
          width: 12%;
          color: #666666;
          text-align: center;
          margin-top: 9px;
        "
        v-if="sizerDetailData.FilterField.conditionValue === 'between'"
      >
        -----
      </div>
      <el-input
        type="number"
        style="margin-top: 3px; width: 44%; float: right"
        v-model="newSizerDetailData.FilterValue[1]"
        class="filter-number-list input-clock"
        :disabled="sizerDisabled"
        @change="transferFun('two_number')"
        v-if="sizerDetailData.FilterField.conditionValue === 'between'"
      />
    </div>

    <!-- 时间 -->
    <div class="scrollItem" v-if="sizerDetailData.FilterField.type === 'date'">
      <el-select
        v-model="newSizerDetailData.FilterField.conditionValue"
        style="width: 100%"
        placeholder="请选择"
        :disabled="sizerDisabled"
        :teleported="true"
        @visible-change="transferStatusFun"
        class="scrollStyleItem"
        @change="dateTypeChange()"
      >
        <el-option
          v-for="(item2, itemIndex) in sizerDetailData.FilterField.condition"
          :key="itemIndex"
          :value="item2.val"
          :label="item2.name"
        />
      </el-select>
      <!-- 时间情形一 -->
      <el-date-picker
        style="margin-top: 10px; width: 100%"
        v-if="
          ['fixed', 'gte', 'lte'].indexOf(
            sizerDetailData.FilterField.conditionValue
          ) !== -1
        "
        v-model="newSizerDetailData.datePickerValue"
        value-format="yyyy-MM-dd"
        type="date"
        :disabled="sizerDisabled"
        placeholder="选择日期"
        @change="transferFun('time')"
      ></el-date-picker>

      <!-- 时间情形二 -->
      <el-date-picker
        style="margin-top: 10px; width: 100%; height: 30px; line-height: 30px"
        v-if="sizerDetailData.FilterField.conditionValue === 'between'"
        v-model="newSizerDetailData.datePickerValue"
        type="daterange"
        :disabled="sizerDisabled"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        @change="transferFun('time')"
      ></el-date-picker>
    </div>

    <!-- 其他 -->
    <div
      class="scrollItem"
      v-if="
        sizerDetailData.FilterField.type === 'file' ||
        sizerDetailData.FilterField.type === 'image'
      "
    >
      <div class="itemTitle">暂无该类型筛选器!</div>
    </div>
  </div>
</template>

<script>
import { getdeptlist } from "@/port/admins/instrument";
import { getopenorganizationlist } from "@/port/clientSide/multipleChoice";
import { openapiGetapproval } from '@/port/clientSide/applicationRouting'
// import { cloneDeep } from "lodash";

export default {
  name: 'sizerDetail',
  props: {
    //- 明细表格数据
    sizerDetailData: {
      type: Object,
      default: () => { return {} }
    },
    sizerIndex: {
      type: Number,
      default: 0
    },
    sizerDisabled: {
      type: Boolean,
      default: false,
    }

  },
  data: function () {
    return {
      width: 217,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultShowNodes: [],
      iSsizer1: false,
      newSizerDetailData: null
    }
  },
  methods: {
    handleClose (index) {
      this.newSizerDetailData.FilterValue.splice(index, 1)
      this.updatePeople()
    },
    getColor (key) {
      const org = this.sizerDetailData.FilterValue[0] || {}
      return org.organizationId && org.organizationId === key ? 'color:#057EFF' : ''
    },
    async handleNodeClick(data) {
      // 这个直接给部门等id 的 只有线上可以调试 edu 没有
      this.newSizerDetailData.FilterValue = [{name: data.name, organizationId: data.organizationId}]
      this.transferFun('orgUser')
    },
    async loadNode(node, resolve) {
      console.log('点击读取', node, resolve)
      // 当这里是列表组件的时候，直接走模板查询获取
      if (this.sizerDetailData.FilterField.datas[0] && this.sizerDetailData.FilterField.datas[0].types) {
        const obj = {approvalId: this.sizerDetailData.FilterField[0].appId}
        if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
          obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        const res = await openapiGetapproval(obj).catch(err => { console.log(err) })
        let list = []
        if (res.code === 0) {
            try {
              const property = JSON.parse(res.data.property)
              const items = this.sizerDetailData.FilterField[0].allDatas[this.sizerDetailData.FilterField[0].checkValue]
              list = this.getSles(property, items)
            } catch(e) {
              console.log('获取错误', e)
            }
        }
        resolve(list)
        return
      }
      const fun = this.sizerDetailData.synchronousOrg ? getdeptlist : getopenorganizationlist
      if (node.level === 0) {
        if (this.sizerDetailData.organize.length > 0 && this.sizerDetailData.organize[0].organizationId) this.defaultShowNodes.push(this.sizerDetailData.organize[0].organizationId)
        if (this.sizerDetailData.organize[0] && this.sizerDetailData.organize[0].organizationId) resolve(this.sizerDetailData.organize)
      } else {
        if (this.defaultShowNodes.length > 0) this.defaultShowNodes = []
        const res = await fun({
          pid: node.data.organizationId,
          curpage: 0,
          pagesize: 0
        })
        if (res.code === 0) {
          resolve(res.data.map(its => {
            return {
              name: its.name,
              organizationId: its.organizationId
            }
          }))
        } else {
          resolve([])
        }
      }
    },
    getSles (arr, key) {
      let list = []
      for (const i of arr) {
        if (key.title === i.title && key.type === i.type) {
          if (i.sels) {
            let sels = i.sels
            if (typeof sels === 'string') sels = JSON.parse(sels)
            list = sels.map(its => its.value || its)
          }
          break
        } else if (i.list && i.list.length > 0) {
          return this.getSles(i.list, key)
        }
      }
      return list
    },
    delFilterValue (index) {
      this.newSizerDetailData.FilterValue.splice(index, 1)
      this.transferFun('textTwo')
    },
    visibleChange (val, key) {
      if (val || this.iSsizer1 === false) {
        this.$refs[key].click()
      }
    },
    getWidth (e) {
      console.log('点击获取宽度', e)
      this.width = e.target.clientWidth - 24
    },
    //- 通知父级页面数据刷新中转
    transferFun (name) {
      this.$emit("transferFun", this.sizerDetailData, name, this.sizerIndex);
    },
    //- 客户端时候通知父级页面筛选组件功能触发，页面不能滚动中转
    transferStatusFun (bool) {
      this.iSsizer1 = bool
      this.$emit("transferStatusFun", bool, this.sizerDetailData);
    },
    //- 全选
    handleCheckAllChange () {
      this.$emit("handleCheckAllChange", this.sizerIndex);
    },
    //- 文本场景二：单表或者表多表不同源前端模糊搜索
    isShowFun (item, searchName) {
      let whetherShow = true;
      if (typeof (item) === "number") {
        item = (item).toString();
      }
      if (typeof (searchName) === "number") {
        searchName = (searchName).toString();
      }
      if (searchName && searchName != "" && item.indexOf(searchName) == -1) {
        whetherShow = false;
      }
      return whetherShow
    },
    //- 联系人单个删除
    updatePeople () {
      this.$emit("updatePeople", this.sizerDetailData, this.sizerIndex);
    },
    //- 数值类型变换
    numberTypeChange () {
      this.$emit("numberTypeChange", this.sizerDetailData, this.sizerIndex);
    },
    //- 时间类型变化
    dateTypeChange () {
      this.$emit("dateTypeChange", this.sizerDetailData, this.sizerIndex);
    },
  },

  computed: {

  },

  watch: {
    sizerDetailData: {
      handler (val) {
        if (val) {
          if (!this.newSizerDetailData) {
            this.newSizerDetailData = val
          }
          if (val.FilterValue && val.FilterValue.length !== 0) {
            if (['organization', 'roule'].includes(val.FilterField.type) ) {
              this.newSizerDetailData.FilterValue = val.FilterValue.map(item => { return item.name || item })
            }
          }
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style scoped lang="scss">
.user-cc {
  width: calc(100% - 20px);
  padding: 3px 8px;
  border: 1px solid #e9e9eb;
  border-radius: 4px;
  position: relative;
  min-height: 28px;
  line-height: 28px;
  color: #909399;
  font-size: 12px;
  cursor: pointer;
  :deep(.el-tag .el-tag__close) {
    background: #C0C4CC;
    color: #909399;
  }
  .sizer-select-bottom {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
  }
}
:deep(.el-input__icon.el-icon-search) {
  margin-top: 0;
}
.sizer-scrollbar {
  height: 100%;
  :deep(.el-scrollbar__wrap) {
    overflow-x: auto;
  }
}
.sizer-select {
  width: calc(100% - 2px);
  height: 28px;
  position: relative;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  .sizer-select-list {
    height: 22px;
    padding: 0 8px;
    line-height: 22px;
    display: inline-block;
    font-size: 12px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    white-space: nowrap;
    background-color: #f5f5f5;
    border-color: #ebebeb;
    color: #999;
    margin: 2px 0 2px 6px;
    .el-icon-error {
      color: #CCD1D6;
      cursor: pointer;
      &:hover {
        color: #99A3AD;;
      }
    }
  }
  .sizer-select-bottom {
    position: absolute;
    right: 9px;
    top: 7px;
    color: #999;
  }
}
.sizer-search {
  /*margin-top: 10px;*/
  display: flex;
  align-items: center;
  :deep(.el-input__inner) {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
  :deep(.el-button) {
    border-radius: 0 2px 2px 0;
  }
  .el-input__icon {
    padding-top: 0;
  }
}
.sizerDetail {
  height: 100%;
}
:deep(.el-select .el-input.is-disabled .el-input__inner),
:deep(.el-input.is-disabled .el-input__icon) {
  cursor: pointer;
}
:deep(.el-select-dropdown) {
  display: none !important;
}
.sizer-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  :deep(.el-checkbox) {
    margin-right: 16px;
    font-size: 13px;
    line-height: 30px;
  }
  :deep(.el-checkbox__label) {
    padding-left: 4px;
  }
}
// 筛选文本类型特殊样式设定
.textStyleTwo {
  width: 100%;
  height: 300px;
  overflow: scroll;
  :deep(.el-input--small .el-input__inner) {
    height: 30px;
    line-height: 30px;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  :deep(.el-checkbox.allCheck) {
    width: 97%;
    margin: 12px 0;
  }
  .teshuStyle :deep(.el-input__inner) {
    cursor: auto !important;
    &:disabled {
      background: white !important;
    }
  }
  .teshuStyle :deep(.el-select__tags) {
    top: auto;
    transform: initial;
  }
}
.scrollItem :deep(.el-input.is-disabled .el-input__inner) {
  background-color: #FFFFFF;
}
.tabItemTree {
  &.enlarge {
    height: 73%;
    margin-top: 9px;
  }
  &.shrink {
    height: calc(100% - 50px);
    margin-top: 9px;
  }
  .el-scrollbar {
    width: 100%;
    height: calc(100% - 30px);
    :deep(.el-scrollbar__wrap) {
      width: 100%;
      /*滚动条样式*/
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        display: none;
      }
      .el-scrollbar__view {
        width: 100%;
        .el-checkbox {
          margin-right: 7px;
          display: block;
          height: 25px;
        }
      }
    }
  }
  .textDataStyle {
    // color: $base-text-unselected-color;
    width: 100%;
    text-align: center;
    font-size: 12px;
    margin-top: 59px;
  }
}
.scrollItem {
  margin-top: 0px;
  position: relative;
  height: 100%;
  .scrollStyleItem {
    :deep(.el-select-dropdown.el-popper) {
      position: fixed !important;
      top: 81px !important;
      left: 12px !important;
    }
    :deep(.el-input__icon.is-reverse) {
      margin-top: -4px !important;
    }
  }
  &.user {
    .scrollStyleItem {
      :deep(.el-select-dropdown.el-popper.is-multiple) {
        display: none !important;
      }
    }
  }
  .selectName {
    position: absolute;
    z-index: 32;
    top: 5vh;
    left: 5.81vw;
    color: #9e9c9c;
    font-size: 12px;
  }
}
</style>
